
<div
 class="container-main"
>
  <div class="FormStyle">
    <div>
      <h1 class="m-0 text-primary">Deal Transaction Page</h1>
      <div class="">Enter the transaction details.</div>
    </div>

    <form [formGroup]="transactionForm" (ngSubmit)="onSubmission()">
      <div style="display: flex; gap: 10px; flex-wrap: wrap">
        <ng-autocomplete
          class="item"
          [data]="filteredOptions"
          [searchKeyword]="keyword"
          placeholder="Store Name"
          (selected)="selectEvent($event)"
          (inputChanged)="onChangeSearch($event)"
          (inputFocused)="onFocused($event)"
          historyIdentifier="filteredOptions"
          [itemTemplate]="itemTemplate"
          initialValue="Amazon"
        >
        </ng-autocomplete>

        <ng-template #itemTemplate let-item>
          <a [innerHTML]="item.siteName"></a>
        </ng-template>
        <mat-form-field class="item" appearance="outline">
          <mat-label>Order Id</mat-label>
          <input
            matInput
            placeholder="Ex. 1223"
            value=""
            formControlName="orderId"
          />
        </mat-form-field>
        <mat-form-field class="item" appearance="outline">
            <mat-label>Order Amount</mat-label>
            <input matInput placeholder="Ex. 1223" value="" formControlName="amount" required>
        </mat-form-field>
        <mat-form-field class="item" appearance="outline">
            <mat-label>Email Id</mat-label>
            <input matInput placeholder="Ex. abc@xyz.com" formControlName="email" value="" required>
        </mat-form-field>
        <mat-form-field class="item" appearance="outline">
            <mat-label>Mobile No.</mat-label>
            <input matInput placeholder="Ex. 999-999-9999" formControlName="mobile" value="" required>
        </mat-form-field>
        <mat-form-field class="item" appearance="outline">
            <mat-label>Date of Transaction</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" required (dateChange)="eventStartDate('change', $event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="item" appearance="outline">
            <mat-label>Description of Deal Purchased</mat-label>
            <textarea placeholder="Dell Inspiron 15" matInput cdkTextareaAutosize cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5" formControlName="description" required></textarea>
        </mat-form-field>
      </div>
      <div class="col-12 mt-4 text-end">
        <button type="submit" class="btn btn-primary">Submit</button>
    </div>
      
    </form>
  </div>
</div>
